import type { SVGProps } from 'react';

export function RookIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.285 2a1.143 1.143 0 0 1 1.135 1.01l.008.134v1.142h1.888l.414-1.33a1.143 1.143 0 0 1 1.181-.955l.133.015a1.143 1.143 0 0 1 .955 1.182l-.015.133-.571 3.428a1.14 1.14 0 0 1-.989.948l-.139.008h-1.58l1.002 9.016a1.143 1.143 0 0 1-1.003 1.26l-.133.009H7.428a1.143 1.143 0 0 1-1.142-1.135l.006-.134 1.003-9.016h-1.58a1.14 1.14 0 0 1-1.098-.82l-.03-.136-.571-3.428a1.143 1.143 0 0 1 2.225-.505l.029.13.412 1.33h1.89V3.144a1.143 1.143 0 0 1 2.277-.134l.008.134v1.142h2.285V3.144A1.143 1.143 0 0 1 14.285 2M18.858 19H5.143a1.23 1.23 0 0 0-.808.292.94.94 0 0 0-.334.707c0 .53.24 1.04.67 1.415.428.375 1.01.585 1.615.585h11.43c.56 0 1.1-.18 1.52-.505.418-.326.685-.776.75-1.262l.013-.174a.9.9 0 0 0-.067-.4 1 1 0 0 0-.243-.345 1.2 1.2 0 0 0-.378-.232 1.3 1.3 0 0 0-.453-.081" />
    </svg>
  );
}
